import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { RxOptDisplayComponent } from "src/app/shared/components/rx-opt-display/rx-opt-display.component";
import {
  RXForm,
  RXNote,
  RXOptGroup,
  RXOptValue,
  RXTooth,
} from "src/app/shared/models/order.model";
import { curRXForm } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
  selector: "rx-implants",
  templateUrl: "./rx-implants.component.html",
  styleUrls: ["./rx-implants.component.scss"],
  imports: [TranslateModule, CommonModule, RxOptDisplayComponent],
  standalone: true,
})
export class RxImplantsComponent {
  @Input() readOnly: boolean;
  @Output() onDeleteRow = new EventEmitter();
  @Output() onChange = new EventEmitter();

  curRow: RXTooth;

  get form(): RXForm {
    return this.store.selectSignal(curRXForm)();
  }

  get implants(): RXTooth[] {
    return this.form.implantTeeth.filter((t) => !t.dirtySw);
  }

  get attachments(): RXOptGroup {
    return this.form.rxOptions.find((o) => o.optGroup == "IMP_ATTACH");
  }

  constructor(
    private readonly store: Store,
    private translateService: TranslateService,
    private sharedService: SharedService
  ) {}

  deleteRow(row: RXTooth) {
    let validationStr = this.translateService.instant(
      "translate.rx.deleteRowValidation"
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: "translate.alert.infoTitle",
      icon: "exclamation-triangle",
      subTitle: validationStr,
      keep: false,
      approve: () => {
        let idx = this.form.implantTeeth.indexOf(row);
        this.form.implantTeeth.splice(idx, 1);
        this.onDeleteRow.emit();
      },
    });
  }

  onCompanyValueChange(value: RXOptValue) {
    this.onChange.emit();
    this.implants.forEach((i) => {
      if (!i.implantCompany.selectedValue) {
        i.implantCompany.selectedValue = value;
      }
    });
  }

  onImplantTypeValueChange(value: RXOptValue) {
    this.onChange.emit();
    this.implants.forEach((i) => {
      i.implantIndivSw.valueBool = false;
      i.implantMultiUnitSw.valueBool = false;
    })
  }

  onOptValueChange() {
    this.onChange.emit();
  }
}
